import React from 'react'

import { getFormattedDate } from '@app/utils/date'

import { LntAlert } from '@app/components/base'

import { dateFormat } from '@app/constants'

import type { PromoDateInfoDto } from '@app/api/routes/monitoringLists/dtos'
import type { ObjectValuesType } from '@app/types'

const getPromoDataText = (
  promoDateInfo: PromoDateInfoDto,
  format: ObjectValuesType<typeof dateFormat> = dateFormat.DD_MM_YYYY
): string => {
  const { dateFrom, dateTo, promotionName, promotionNumber } = promoDateInfo

  const dateFromFormated = getFormattedDate(dateFrom, format)
  const dateToFormated = getFormattedDate(dateTo, format)
  const datePeriod = `${dateFromFormated ?? ''} - ${dateToFormated ?? ''}`

  return [promotionNumber, promotionName, datePeriod].filter(Boolean).join(', ')
}

export const PromoAlert: React.FC<PromoDateInfoDto> = promoDateInfo => {
  return (
    <LntAlert
      type='info'
      message={ getPromoDataText(promoDateInfo) }
      showIcon
    />
  )
}
